<template>
	<div class="relative" :class="context.classes.inner">
		<VueDatePicker
			:id="context.id"
			v-model="date"
			:enable-time-picker="false"
			:format="formatDate"
			:placeholder="context.attrs.placeholder || ''"
			:state="context.state.valid"
			:inline="context.attrs.inline"
			:max-date="context.attrs['max'] || null"
			:min-date="context.attrs['min'] || null"
			:ui="{input: `
				shadow-none
				pl-4
				py-[0.6375rem]
				typo-body-s
				focus-outline
				border-border-primary active:border-border-select
				disabled:bg-background-disabled disabled:border-border-secondary
				${context.state.valid ? 'border-border-tertiary' : 'border-functional-error-primary'}
				${props.context.classes.input}
			`}"
			:clearable="false"
			locale="cs"
			auto-apply
			:text-input="{
				format: 'd. M. yyyy',
			}"
			:disabled="!!context.disabled"
			@update:model-value="handleChange"
		>
			<template #input-icon>
				<NuxtIcon
					name="calendar"
					class="text text-body-tertiary py-2 px-2.5 pr-4 block"
					filled
				/>
			</template>
		</VueDatePicker>
		<span v-if="props.context.attrs.inline" v-html="props.context.attrs.inline" />
	</div>
</template>
<script setup lang="ts">
	import {format} from 'date-fns';
	import VueDatePicker from '@vuepic/vue-datepicker';
	import type {DatepickerContext} from '~/types/formkitDatepicker';

	interface Props {
		context: DatepickerContext
	}

	const props = defineProps<Props>();
	const date = ref(props.context.node.value as Date ?? null);

	const handleChange = (value: DatepickerContext['_value']) => {
		props.context.node.input(value);
	};

	function formatDate(date: Date) {
		return format(date, 'd. M. yyyy');
	}
</script>

<style scoped>
	@reference "../../assets/css/main.css";

	.dp__main:deep(.dp__input_icon) {
		@apply right-0 left-auto;
	}
</style>
